import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { PlayerLockProvider } from './contexts/PlayerLockContext'
import './index.css'
import { logEnvironmentInfo } from './env-debug'

// Log environment information in both dev and prod
logEnvironmentInfo();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PlayerLockProvider>
      <App />
    </PlayerLockProvider>
  </React.StrictMode>,
)